import { formatNumber } from "utils/projectDisplay"

interface Props {
  soldCount: number
  totalCount: number
  loading?: boolean
}

const WorkSaleProgress = ({ soldCount, totalCount, loading = false }: Props) => {
  const hasCounts = totalCount > 0
  const progress = hasCounts ? Math.min(100, Math.round((soldCount / totalCount) * 100)) : 0
  const soldLabel = hasCounts ? `${formatNumber(soldCount)} / ${formatNumber(totalCount)} sold` : "Checking chain"
  const percentLabel = hasCounts ? `${progress}%` : loading ? "..." : "0%"

  return (
    <>
      <div className="gallery-card-foot">
        <span>{soldLabel}</span>
        <span>{percentLabel}</span>
      </div>
      <div
        className="gallery-progress"
        aria-label={hasCounts ? `${soldLabel}, ${percentLabel}` : "Checking chain sale data"}
      >
        <span style={{ width: `${progress}%` }} />
      </div>
    </>
  )
}

export default WorkSaleProgress
